<template>
  <div class="list-card-recommended">
    <!-- Column -->
    <div
      v-for="(item, index) in dataCards"
      :key="index"
      class="card-recommended"
    >
      <!-- Article -->
      <div class="p-4">
        <article class="max-w-full">
          <img class="block h-auto w-full" :src="item.imgSrc" @click="onMove"/>
          <Tag
            :text="'旅'"
            :color="'#DA291C'"
            :bgColor="'#F4F5F6'"
          />
          <h1>{{ item.title }}</h1>
          <p>
            {{ item.content }}
          </p>
        </article>
      </div>
      <!--END Article -->
    </div>
    <!-- END Column -->
  </div>
</template>

<script>
import Tag from '@/components/primitive/Tag'

export default {
  components: {
    Tag
  },
  props: {
    onMove: Function
  },
  methods: {
    routerTo() {
    }},
  data() {
    return {
      dataCards: [
        {
          id: 1,
          title: 'GW海外旅行特集',
          content:
            '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…',
          imgSrc: require('@/assets/images/BS_SPE_01/list.png')
        },
        {
          id: 2,
          title: 'GW海外旅行特集',
          content:
            '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…',
          imgSrc: require('@/assets/images/BS_SPE_01/list.png')
        },
        {
          id: 3,
          title: 'GW海外旅行特集',
          content:
            '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…',
          imgSrc: require('@/assets/images/BS_SPE_01/list.png')
        },
        {
          id: 4,
          title: 'GW海外旅行特集',
          content:
            '令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめての春休み、そしてゴールデンウィーク♪令和になってはじめ…',
          imgSrc: require('@/assets/images/BS_SPE_01/list.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
::v-deep .ant-tag{
  @apply mt-2 mb-4;
  border-radius: 8px;

}
</style>